import QuillBlock, { BlockEmbed } from 'quill/blots/block';
import type { Parchment } from 'quill/core';
import type { Line } from './types';

const closestLine = (blot: Parchment.Blot | null | undefined): Line | null => {
  let current = blot;
  while (current) {
    if (current instanceof QuillBlock || current instanceof BlockEmbed) {
      return current;
    }
    current = current.parent;
  }
  return null;
};

export default closestLine;
